$(function () {
    new WOW().init();

    $('.gallery-item a').fancybox({
        'autoWidth': true,
        'padding': 0
    });
    $('a[rel=lightbox]').fancybox();

    if (!jQuery.browser.mobile) {
        $('.navbar-nav').addClass('desktop');
    } else {
        $('.navbar-nav').addClass('mobile');
    }

    $("#v-pills-tab").on("click hover", function (e) {
        e.preventDefault();
        $(this).tab("show");
    });

    // главная
    indexIncrement();
    // easter egg
    console && console.log("%c", 'font-size: 1px; color: transparent; padding: 50px 87px;line-height: 1; background-image: url("http://' + location.host + '/assets/template/images/orbrm_logo.png"); background-repeat: no-repeat;');
    // калькулятор
    setDigitizing();
    // валидация форм
    validation();
    // отправка форм
    $(document).on("af_complete", function (event, response) {
        if (!response.success) return false;
        var $form = $(response.form);
        var $successBlock = $form.find(".form-success");
        if (!!$successBlock.length) {
            $successBlock.addClass('show');
            setTimeout(function () {
                $(".modal").modal('hide');
                $successBlock.removeClass('show');
            }, 3000);
        }
    });

    //$(".parallax").parallax("left top", 0.3);

    // Smooth scrolling
    smoothAnchorScrolling();
});

// счетчик на главной
function indexIncrement() {
    var countbox = ".index-counter-wrap";
    var showCount = true;

    if ($(countbox).length) {
        $(window).on("scroll resize", function () {
            if (!showCount) return false;
            var e_top = $(countbox).offset().top;
            var w_top = $(window).scrollTop();

            var delta = 1050;
            var dcf = 2;

            if (w_top + delta >= e_top) {
                $(".increment:not(.decimal)").each(function (e, i) {
                    $(this).animateNumber({
                        number: $(this).text(),
                        numberStep: $.animateNumber.numberStepFactories.separator(' ')
                    }, 1500);
                });
                $(".increment.decimal").each(function (e, i) {
                    $(this).animateNumber({
                        number: $(this).text() * dcf,
                        numberStep: function (now, tween) {
                            var floored_number = Math.floor(now) / dcf,
                                target = $(tween.elem);

                            floored_number = floored_number.toFixed(1);
                            floored_number = floored_number.toString().replace('.', ',');
                            target.text(floored_number);
                        }
                    }, 1500);
                });
                showCount = false;
            }
        });
    }
}
// калькулятор
function setDigitizing() {
    if ($("#calcForm").length) {
        var CalcForm = {
            config: {
                pages: "[name=doc-pages]",
                size: "[name=doc-size]",
                type: "[name=doc-type]:checked",
                scantype: "[name=doc-scan]",
                resolution: "[name=doc-res]",

                form: "#calcForm",
                total: "#calc-total",
                resultBlock: ".calc-result"
            },
            process: function () {
                $(this.config.form).on("submit", function (e) {
                    e.preventDefault();
                    values = {
                        pagesCount: $(CalcForm.config.pages).val() || 0,
                        type: $(CalcForm.config.type).val() || 0,
                        size: $(CalcForm.config.size).val() || 0,
                        scantype: $(CalcForm.config.scantype).val() || 0,
                        price: 0
                    };

                    if (!!!Rates[values.type][values.size] || values.pagesCount == 0)
                        return false;

                    var rate = Rates[values.type][values.size];
                    var currentRate = rate[values.scantype];
                    values.price = CalcForm.formatNum(currentRate * values.pagesCount);
                    $(CalcForm.config.resultBlock).hide();
                    $(CalcForm.config.total).text(values.price);
                    $(CalcForm.config.resultBlock).fadeIn();
                });
            },
            formatNum: function (num) {
                if (isNaN(num))
                    return num;
                var separator = " "; // разделитель
                strNum = Math.round(num);
                strNum = strNum.toString();
                var strNew = strNum.substring(strNum.length);
                var countNum = 0;
                for (var i = strNum.length; i > 0; i--) {
                    if ((countNum % 3 == 0) && (i != strNum.length)) {
                        strNew = separator + strNew;
                    }
                    strNew = strNum.charAt(i - 1) + strNew;
                    countNum++;
                }
                return strNew;
            }
        };
        CalcForm.process();
    }
}
// валидация
function validation() {
    $(".needs-validation").each(function () {
        var $form = $(this);
        $form.on("submit", function (e) {
            if ($form[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
            }
            $form.addClass("was-validated");
        });
    });
};

/*$.fn.parallax = function(bgPos, step) {
    console.log('ss');
    var winHeight = $(window).height();
    function setBgPos() {
        var scrollPos = $(window).scrollTop();
        object.each(function() {
            var $this = $(this);
            var topOffset = $(this).offset().top;
            var height = $this.height();
            if (topOffset + height < scrollPos || topOffset > scrollPos + winHeight) {
                return
            }
            $this.css("backgroundPosition", bgPos + " " + Math.round((offsetTop - scrollPos) * step) + "px")
        })
    }
    var object = $(this);
    var offsetTop;
    var f = 0;
    object.each(function() {
        offsetTop = object.offset().top
    });

    if (arguments.length < 1 || bgPos === null)
        bgPos = "50%";
    if (arguments.length < 2 || step === null)
        step = .1;

    $(window).on("scroll", setBgPos).resize(setBgPos);
    setBgPos();
}*/

function smoothAnchorScrolling() {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').on('click', function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 50
                }, 1000, function() {
                    // Callback after animation
                    // Must change focus!
                    /*var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };*/
                });
            }
        }
    });
}